import moment from 'moment-timezone';

import { globalFilterActionsPrefix } from '../constants/filter';
import { DAY_BEGIN, FULL_DATE_FORMAT } from '../constants/date';
import { createFilterReducer } from './filter';

const additionalHandlers = {
  METAINF_RESPONSE: (state) => ({
    ...state,
  }),

  GLOBAL_FILTER_CHANGE_EVENT: (state, action) => ({
    ...state,
    event: action.event,
    clauses: state.clauses,
  }),

  UPDATE_LOCATION: (state) => ({
    ...state,
    event: null,
    clauses: state.clauses,
  }),

  CHANGE_RANGE: (state, action) => ({
    ...state,
    from: action.from,
    to: action.to,
  }),

  FETCH_PROJECT_OPTIONS_SUCCESS: (state, action) => ({
    ...state,
    from: moment
      .tz(action.options.zoneId)
      .set(DAY_BEGIN)
      .subtract(1, 'month')
      .format(FULL_DATE_FORMAT),
    to: moment.tz(action.options.zoneId).set(DAY_BEGIN).add(1, 'days').format(FULL_DATE_FORMAT),
  }),
};

const initialState = {
  from: moment().subtract(1, 'month').format('YYYY-MM-DD'),
  to: moment().format('YYYY-MM-DD'),
};

export const getFrom = (state) => state.from;

export const getTo = (state) => state.to;

export default createFilterReducer(globalFilterActionsPrefix, additionalHandlers, initialState);

export const getEvent = (state) => state.event;
